module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<span class="bvcompte phx-label-style"></span>\r\n<span class="cw-texteRubrique">\r\n    <span class="bvcompteurs-compteurs-instantanes cw-texteNormal"></span>\r\n</span>\r\n<span class="bvcompteurs-valorisation"></span><br>\r\n<span class="bvcompteurs"></span>';
}
return __p;
};
